export default [
  {
    path: '/main/vehiclebrands',
    meta: {
      tag: 'list_vehiclebrand',
      name: 'Marcas de Veículo',
      breadcrumb: 'Marcas de Veículo'
    },
    component: () => import(/* webpackChunkName: "vehiclebrands-list" */ '@/views/main/settings/test-registers/vehiclebrands/Index.vue'),
    children: [
      {
        path: '',
        name: 'listvehiclebrands',
        meta: {
          tag: 'list_vehiclebrand',
          menu: 'settings',
          name: 'Marcas de Veículo'
        },
        component: () => import(/* webpackChunkName: "vehiclebrands-list" */ '@/views/main/settings/test-registers/vehiclebrands/List.vue'),
      },
      {
        path: '/main/vehiclebrands/add',
        name: 'addvehiclebrand',
        meta: {
          tag: 'add_vehiclebrand',
          menu: 'settings',
          name: 'Adicionar | Marca de Veículo',
          breadcrumb: 'Adicionar Marca de Veículo'
        },
        component: () => import(/* webpackChunkName: "vehiclebrands-add" */ '@/views/main/settings/test-registers/vehiclebrands/Add.vue')
      },
      {
        path: '/main/vehiclebrands/:id',
        name: 'editvehiclebrand',
        meta: {
          tag: 'edit_vehiclebrand',
          menu: 'settings',
          name: 'Editar | Marca de Veículo',
          breadcrumb: 'Editar Marca de Veículo'
        },
        component: () => import(/* webpackChunkName: "vehiclebrands-edit" */ '@/views/main/settings/test-registers/vehiclebrands/Edit.vue')
      }
    ]
  },
]
  